<div class="input-group mat-elevation-z3 r-8">
  <div class="input-group-prefix dark-background r-t-l-8 r-b-l-8 p-8">
    <label>
      {{ prefix }}
    </label>
  </div>
  <div class="input-group-input">
    <ng-content></ng-content>
  </div>
  <div class="input-group-suffix dark-background r-t-r-8 r-b-r-8 p-8">
    <label>
      {{ suffix }}
    </label>
  </div>
</div>
